var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoPage"},[_c('div',{staticClass:"dialogBox"},[_c('h1',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.message2))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message3))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1885c346","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Info.vue
// module id = null
// module chunks = 